import type { Query } from '../query'

import type { Context } from './context'
import type { Graph } from './graph'
import * as node from './node'
import * as utils from './utils'

/**
 * Creates a {@link Graph} from a {@link Query}
 */
export function from(query: Query, context: Context): Graph {
  const nodesCache = new node.Cache()
  const root = node.from(query, {
    ...context,
    nodesCache,
    // Additional variables will be added from the `query`
    variables: {},
  })
  return {
    // NOTE: arrow function avoids exposing additional args (in case
    // additional args are ever added to the method on nodesCache)
    getNode: identifier => nodesCache.get(identifier),
    // NOTE: if this is an aggregate query (i.e. no target) or it explicitly
    // requests one item and does not disable unpacking, then we return a
    // single item. Otherwise, we return a list
    resultsAsSingleton: utils.determineIfResultsShouldBeSingleton({
      node: root,
      schema: context.schema,
    }),
    root,
    // NOTE: arrow function avoids exposing additional args (in case
    // additional args are ever added to the method on nodesCache)
    tryGetNode: identifier => nodesCache.tryGet(identifier),
  }
}
